<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'订单管理'},{title:'新建采购订单'}]"/>

        <div class="h-content cgddthrids">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form
                                :model="zy"
                                label-position="right"
                                ref="form1"
                                :rules="rules"
                                :inline="true"
                                class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">


                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>基本信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine weekplandetail111">
                                            <el-form-item label="订单总价" class="h-elformWrap-2">
                                                <el-input readonly placeholder="自带出" v-model="zy.totalPrice"
                                                          type="number"></el-input>
                                            </el-form-item>
                                            <el-form-item label="采购单类型" class="h-elformWrap-2">
                                                <brselect
                                                        category="cg_type"
                                                        :v="zy.type"
                                                        @change="callFun"
                                                        v-model="zy.type">
                                                </brselect>
                                            </el-form-item>
                                            <el-form-item label="期望到货时间" class="h-elformWrap-2" prop="expectDate">
                                                <div class="block">
                                                    <el-date-picker
                                                            v-model="zy.expectDate"
                                                            type="date"
                                                            value-format="yyyy-MM-dd"
                                                            placeholder="--选择--">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="采购组织" class="h-elformWrap-2" prop="purchaseOrgCode">
                                                <brselect
                                                        clearable
                                                        category="purchase_org_code"
                                                        :v="zy.purchaseOrgCode"
                                                        @change="changeCgGroup"
                                                        v-model="zy.purchaseOrgCode">
                                                </brselect>
                                            </el-form-item>
                                            <el-form-item label="采购组" class="h-elformWrap-2" prop="cgGroupCode">
                                                <mdmselect
                                                        clearable
                                                        disabled
                                                        :showcode="true"
                                                        category="YLPurchaseGroup"
                                                        :v="zy.cgGroupCode"
                                                        v-model="zy.cgGroupCode">
                                                </mdmselect>
                                            </el-form-item>
                                            <el-form-item label="备注" class="h-elformWrap-2" prop="notes">
                                                <el-input placeholder="请输入" v-model="zy.notes"></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货仓库" prop="warehouse" v-if="ckFlag" class="h-elformWrap-2">
                                                <el-select v-model="zy.warehouse" :clearable="true" @change="changeWarehouse"
                                                           placeholder="请选择">
                                                    <el-option label="青岛库" value="青岛库"></el-option>
                                                    <el-option label="苏州库" value="苏州库"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item prop="hhxmCode" label="项目合同" v-if="hhxmFlag"  class="h-elformWrap-2">
                                                <el-select v-model="zy.hhxmCode" clearable filterable :v="zy.hhxmCode" @change="changeHhxmCode(zy.hhxmCode)" placeholder="请选择" clearable style="width:100%">
                                                    <el-option v-for="item in hhxmList"
                                                               :key="item.id"
                                                               :label="item.contractName +'-'+ item.id"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item
                                                    prop="startTimeHhxm"
                                                    label="质保开始时间"
                                                    v-if="isHHxm"
                                                    class="h-elformWrap-2"
                                                    width="100%">
                                                <div class="block">
                                                    <el-date-picker
                                                            v-model="zy.startTimeHhxm"
                                                            type="date"
                                                            :clearable="false"
                                                            placeholder="--请先选择质保开始日期--"
                                                            value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                            <el-form-item
                                                    prop="endTimeHhxm"
                                                    label="质保结束时间"
                                                    v-if="isHHxm"
                                                    class="h-elformWrap-2"
                                                    width="100%" >
                                                <div class="block">
                                                    <el-date-picker
                                                            v-model="zy.endTimeHhxm"
                                                            type="date"
                                                            :clearable="false"
                                                            placeholder="--请先选择质保开始日期--"
                                                            value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>

                                        </div>
                                    </div>
                                </div>


                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>物流信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine weekplandetail111">
                                            <el-form-item label="物流类型" class="h-elformWrap-2" prop="waybillType">
                                                <el-select
                                                        v-model="zy.waybillType"
                                                        placeholder="请选择">
                                                    <el-option
                                                            v-for="(item,index4) in options1"
                                                            :key="index4"
                                                            :label="item.name"
                                                            :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="接收人" class="h-elformWrap-2" prop="receiver">
                                                <el-input placeholder="请输入" v-model="zy.receiver"></el-input>
                                            </el-form-item>
                                            <el-form-item label="接收人手机号" class="h-elformWrap-2" prop="receverPhone">
                                                <el-input placeholder="请输入" v-model="zy.receverPhone"></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货单位" class="h-elformWrap-2" prop="receiveUnit">
                                                <el-input placeholder="请输入" v-model="zy.receiveUnit"></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货地址" class="h-elformWrap-2" prop="detailAddress">
                                                <el-input clearable v-model="zy.detailAddress" placeholder="请输入**省/**市/**区/详细地址"
                                                         >
                                                    <i
                                                            class="el-icon-search el-input__icon"
                                                            slot="suffix"
                                                            @click="selectAreadialog">
                                                    </i>
                                                </el-input>
                                            </el-form-item>
                                            <el-button class="h-btn h-bBtn h-bgblueQ2" style="margin-right: 0px"
                                                       @click="saveDefault()">保存默认信息
                                            </el-button>

                                        </div>
                                    </div>
                                </div>

                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>附件信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine weekplandetail111">
                                            <el-form-item label="附件" class="h-elformWrap-2" prop="fileId">
                                                <brupload
                                                        :refid="zy.fileId"
                                                        reftype="采购订单附件"
                                                        :uploadflag="true"
                                                        :delflag="true"
                                                        :showtime="false"
                                                        @filecallback=upload>
                                                        >
                                                </brupload>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>


                                <div class="N-chan">
                                    <div class="h-pieceTitle2">
                                        <h1>型号信息</h1>
                                    </div>
                                    <div class="yxtable ljjtable">
                                        <el-table
                                                ref="multipleTable"
                                                :data="tableData3"
                                                style="width: 100%"
												border
                                        >
                                            <el-table-column
                                                    type="index"
                                                    width="40"
                                                    label="#">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="productNo"
                                                    label="产品编码"
                                                    width="180">
                                                <template slot-scope="scope">
                                                    <el-select
                                                            v-model="scope.row.productNo"
                                                            placeholder="请选择"
                                                            filterable
                                                            :filter-method="getOEMProduct"
                                                            :remote-method="getOEMProduct"
                                                            @change="changeSmailWl(scope.row,$event)">
                                                        <el-option
                                                                v-for="(item,index2) in productOptions"
                                                                :key="item.id"
                                                                filterable
                                                                :label="item.id"
                                                                :value="item">
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
											<el-table-column
											        prop="productDes"
											        label="产品型号"
											        width="240">
												<template slot-scope="scope">
													<el-select
															v-model="scope.row.productDes"
															placeholder="请选择"
															filterable
                                                            :filter-method="getOEMProduct"
                                                            :remote-method="getOEMProduct"
                                                            @change="changeSmailWl(scope.row,$event)">
														<el-option
																v-for="(item,index2) in productOptions"
																:key="index2"
																filterable
																:label="item.levelname"
																:value="item">
														</el-option>
													</el-select>
												</template>
											</el-table-column>
                                            <el-table-column
                                                    prop="productCate"
                                                    label="产品大类"
                                                    width="140">
                                                <template slot-scope="scope">

                                                    <el-select
                                                            v-model="scope.row.productCate"
                                                            placeholder="请选择"
                                                            filterable
                                                            disabled
                                                            @change="changeBig(scope.row)">
                                                        <el-option
                                                                v-for="(item,index) in productType"
                                                                :key="index"
                                                                :label="item.levelname"
                                                                :value="item.id">
                                                        </el-option>
                                                    </el-select>

                                                </template>

                                            </el-table-column>

                                            <el-table-column
                                                    prop="oemDesc"
                                                    label="规格型号"
                                                    width="110"
                                                    :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    {{scope.row.oemDesc}}
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                    prop="suserCode"
                                                    label="供应商名称"
                                                    min-width="240"
                                            >
                                                <template slot-scope="scope">

                                                    <el-select
															style="width: 100%;"
                                                            v-model="scope.row.suserCode"
                                                            placeholder="请选择"
                                                            filterable
                                                            @change="changeSup(scope.row)">
                                                        <el-option
                                                                v-for="(item,index3) in scope.row.options2"
                                                                :key="index3"
                                                                :label="item.finalSupplierName"
                                                                :value="item.finalSupplier">
                                                        </el-option>
                                                    </el-select>

                                                </template>

                                            </el-table-column>
                                            <el-table-column
                                                    prop="unitPrice"
                                                    label="产品单价"
                                                    width="140">
                                                <template slot-scope="scope">
                                                    <el-input readonly placeholder="自带出" v-model="scope.row.unitPrice">
                                                         {{ scope.row.unitPrice = (scope.row.specialPrice!=null?scope.row.specialPrice:scope.row.unitPriceE) }}
                                                    </el-input>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                    prop="currency"
                                                    label="币种"
                                                    width="110"
                                                    :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    {{scope.row.currency | dictname('YLCurrency')}}
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                    prop="specialPrice"
                                                    label="产品特价"
                                                    min-width="140"
                                            >
                                                <template slot-scope="scope">
                                                    <el-select
                                                            style="width: 100%;"
                                                            v-model="scope.row.specialOfferCode"
                                                            placeholder="请选择"
                                                            @change="changeTejia($event,scope.row)"
                                                            clearable>
                                                        <el-option
                                                                v-for="(item,index3) in scope.row.options2"
                                                                :key="index3"
                                                                :label="item.proDiscPrice"
                                                                :value="item.sid">
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="avaiNumber"
                                                    label="特价余量"
                                                    width="130">
                                                <template slot-scope="scope">
                                                    <el-input readonly placeholder="自带出"
                                                              v-model="scope.row.avaiNumber"></el-input>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                    prop="count"
                                                    label="产品数量"
                                                    width="130">
                                                <template slot-scope="scope">


                                                    <el-input type="text" placeholder="请输入" v-model="scope.row.count"
                                                              maxlength="10"
                                                              @change="changeNum(scope.row)"></el-input>

                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                    prop="note1"
                                                    label="备注"
                                                    min-width="160"
                                            >
                                                <template slot-scope="scope">
                                                    <el-input class="h-tableInput" v-model="scope.row.yremark"
                                                              placeholder="请输入"
                                                              auto-complete="off"></el-input>
                                                </template>
                                            </el-table-column>


                                            <el-table-column
                                                    label="操作"
                                                    width="100"
                                                    fixed="right"

                                            >
                                                <template slot-scope="scope">
                                                    <el-button type="text" size="small" class="h-tableLink h-btn"
                                                               @click="delPlan(scope.$index,scope.row)">删除
                                                    </el-button>
													<!-- <div class="l-operationBox">
														<span class="l-operationlist br-operation-delete" title="删除" @click="delPlan(scope.$index,scope.row)"></span>
													</div> -->
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <div class="h-tableAdd" @click="adds">
                                            <a>新增一行</a>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
                <el-button v-if="zy.status == 0 || zy.status ==''" class="h-btn h-bBtn h-bggreen" @click="save">暂存
                </el-button>
                <el-button v-if="zy.status == 0 || zy.status == 6 || zy.status ==''" class="h-btn h-bBtn h-bgblueQ2"
                            @click="submit('form1')">确认提交
                </el-button>
            </div>
            <!--地址信息-->
            <areaSelect
                    :visible.sync="showdizhiflag"
                    v-if="showdizhiflag"
                    @choseObj="choseDizhi"
            />
        </div>


    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import big from 'big.js'
    import util from "../../utils/util";

    export default {
        data() {
            return {

                shenpixianshi: [],

                peizhi1: null,

                peizhi2: null,

                peizhi3: null,

                chakanyemian: false,

                yaoshanchude: [],

                tableData3: [],


                status: 1,
                //带线表单
                value: false,
                newOrBid: true,
                options1: [{
                    code: '2',
                    name: '外部物流'
                }],
                options2: [],
                productOptions: [],
                productType: [],
                cgId: this.$route.query.cgId,
                ywId: this.$route.query.ywid,
                instId: this.$route.query.instid,
				ycId: this.$route.query.ycId,
               /* refid:this.$util.getUuid(),*/
                zy: {
                    numlist: null,
                    suserCode: '',
                    productCate: '',
                    type: '',
                    productNo: '',
                    waybillType: '',
                    unitPrice: '',
                    count: '',
                    totalPrice: '',
                    detailAddress: '',
                    expectDate: '',
                    productCateName: '',
                    productDes: '',
                    suserName: '',
                    status: 0,
                    proId: '',
                    cgGroupCode: '',
                    province: '',
                    city: '',
                    country: '',
					purchaseOrgCode:"",
                    fileId: this.$util.getUuid(),
                    receiveUnit:null,
                    receverPhone:null,
                    receiver:null,
                    warehouse:null,
                    notes:null,
                },
                rules: {
                    waybillType: [
                        {required: true, message: '请选择物流类型', trigger: 'change'}
                    ],
                    expectDate: [
                        {required: true, message: '请选择期货时间', trigger: 'change'},
                    ],
                    receiveUnit: [
                        {required: true, message: '请输入收货单位', trigger: 'blur'}
                    ],
                    receiver: [
                        {required: true, message: '请输入接收人', trigger: 'blur'}
                    ],
                    receverPhone: [
                        {required: true, message: '请输入接收人手机号', trigger: 'blur'},
                        {
                            pattern: /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/,
                            message: '请输入正确的手机号'
                        }
                    ],
                    detailAddress: [
                        {required: true, message: '请输入收货地址', trigger: 'blur'}
                    ],
                    // unitPrice: [
                    //     {required: true, message: '产品单价根据产品型号带出不允许为空', trigger: 'blur'}
                    // ],
                    cgGroupCode: [
                        {required: true, message: '请选择采购组', trigger: 'blur'}
                    ],
					purchaseOrgCode: [
					    {required: true, message: '请选择采购组织', trigger: 'blur'}
					],
                    fileId: [
                        {required: true, message: '请上传附件', trigger: 'blur'}
                    ],


                },
                vs: {
                    productId: ''
                },
                showdizhiflag: false,
				q: {
				    pageSize: 100,
				    pageNo: 1,
				    total: 0,
				    id: '',
				},
                ckFlag:false,
                hhxmFlag:false,
                isHHxm:false,
                hhxmList:[],
            }
        },

        mounted() {

            //加载大类
            this.selectProduct1()

            //转发页加载
            this.zhuanfachushijiazai();

			//外销预测信息加载
			this.wxycload();

			this.getCgDefault();

        },
        methods: {
          //采购单类型选择监听
          callFun(obj){
            this.tableData3 = []

          },

            //特价改变
            changeTejia(scode, row) {
                console.log('特价改变', scode, row)
                if (row.specialOfferCode) {
                    const tjobj = _.find(row.options2, {sid: row.specialOfferCode})
                    row.specialPrice = tjobj.proDiscPrice;
                    row.avaiNumber = tjobj.avaiNumber;
                    row.sid = tjobj.sid;
                } else {
                    row.specialOfferCode = null;
                    row.specialPrice = null;
                    row.avaiNumber = null;
                    row.sid = null;
                }
            },

			wxycload() {
				if (this.ycId!=null && this.ycId!='') {
					this.q.id = this.ycId;
					ss.waixiao.showDingdlist(this.q).then(rd => {
						if (rd) {
							if (rd.protype!=null && rd.protype=="OEM"){
								var data = {
									"productCate":rd.cpdlName,
									"productNo":rd.proCode,
									"count":rd.proNumber,
									"productOptions":[{id:rd.proCode,levelname:rd.proModel}],
                                    "currency":rd.currency
								};
								this.changeSmail(data,1);
								this.tableData3.push(data);
							}
							// this.zy.expectDate = rd.deliveryDate+" 00:00:00";
						}
					})
				}
			},

            getOEMProduct(value){
                console.log(value)
                ss.ProService.getOEMProduct(value).then(rd => {
                    this.productOptions = rd
                })
            },

            //小类修改，当块数据proProduct[i]-v
            changeSmail(v,flag) {

                v.unitPrice = '';
                this.zy.totalPrice = '';

                v.count = '';

                // this.options1 = [];
                v.proId = '';
                //设置产品型号名称
				if (flag == 1) {
					v.productOptions.forEach((item, index) => {
					    if (v.productNo == item.id) {
					        v.productDes = item.levelname;
					        v.oemDesc = item.oemDesc;
					    }
					})
				} else if (flag == 2) {
					v.productOptions.forEach((item, index) => {
					    if (v.productDes == item.levelname) {
					        v.productNo = item.id;
                            v.oemDesc = item.oemDesc;
					    }
					})
				}

                // //暂时注释掉获取单价接口
                v.options2 = [];
                v.suserCode = '';
                v.suserName = '';
                this.vs = {};
                //获取供应商列表
                if (v.productNo) {
                    this.vs.productId = v.productNo;
                    ss.ProService.supplierByProductId(this.vs).then(rd => {
                        if (rd && rd.length > 0) {
                            //供应商信息
                            v.options2 = rd;
                            v.options2.forEach((item, index) => {
                                let canshu = {};
                                canshu.suserCode = item.finalSupplier;
                                canshu.productNo = v.productNo;
                                //查询供应商商品占比
                                // selectProSupplier(x) {
                                //     this.proSupplier = {};
                                ss.orderCgService.selectProSupplier(canshu).then(rd => {
                                    console.log('我在这儿呀111', rd);
                                    // item.finalSupplierName = item.finalSupplierName + ',产品供应量占比: ' + rd.proportion;
                                })
                                // },;
                            })
                            console.log('我在这儿呀000', v.options2);

                            this.$set(v.options2, rd);
                        }
                    })
                }
            },

            changeSmailWl(v,value) {

                v.productNo = value.id;
                v.productDes = value.levelname;
                v.productCate = value.productCate;
                this.productType.forEach((item, index) => {
                    if (v.productCate == item.id) {
                        v.productCateName = item.levelname;
                    }
                })

                v.unitPrice = '';
                v.unitPriceE = '';
                v.currency = '';
                this.zy.totalPrice = '';

                v.count = '';

                // this.options1 = [];
                v.proId = '';
                //设置产品型号名称

                // //暂时注释掉获取单价接口
                v.options2 = [];
                v.suserCode = '';
                v.suserName = '';
                this.vs = {};
                //获取供应商列表
                if (v.productNo) {
                    this.vs.productId = v.productNo;
                    ss.ProService.supplierByProductId(this.vs).then(rd => {
                        if (rd && rd.length > 0) {
                            //供应商信息
                            v.options2 = rd;
                            v.options2.forEach((item, index) => {
                                let canshu = {};
                                canshu.suserCode = item.finalSupplier;
                                canshu.productNo = v.productNo;
                                //查询供应商商品占比
                                // selectProSupplier(x) {
                                //     this.proSupplier = {};
                                ss.orderCgService.selectProSupplier(canshu).then(rd => {
                                    console.log('我在这儿呀111', rd);
                                    // item.finalSupplierName = item.finalSupplierName + ',产品供应量占比: ' + rd.proportion;
                                })
                                // },;
                            })
                            console.log('我在这儿呀000', v.options2);

                            this.$set(v.options2, rd);
                        }
                    })
                }
            },

            //供应商名字
            changeSup(v) {
                v.options2.forEach((item, index) => {
                    if (v.suserCode == item.finalSupplier) {

                        v.suserName = item.finalSupplierName;
                        v.unitPrice = item.unitPrice;
                        v.proId = item.contractId;
                        v.currency = item.currency;
                        v.unitPriceE = item.unitPrice;
                    }
                })
            },

            //转发加载
            zhuanfachushijiazai() {

                if (this.cgId != null || (this.ywId != null && this.instId != null)) {

                    var yewuid = this.cgId != null ? this.cgId : this.ywId;

                    //查看订单详情
                    ss.orderCgService.caigouselectById(yewuid).then(rd => {

                        console.log(rd.obj, 'rd.obj')

                        if (rd.obj) {

                            //加载自己信息
                            this.jiazaiobjxinxi(rd.obj);

                            //若兄弟信息存在
                            if (rd.obj.orderCgList) {

                                //加载兄弟信息
                                // this.jiazaixiongdi(rd.obj.orderCgList);
								rd.obj.orderCgList.forEach(oc=>{
									this.tableData3.push({
										cgId: oc.cgId || '',
										zhubiaoid: oc.zhubiaoid || '',
										productCateName: oc.productCateName,
										productDes: oc.productDes,
										productCate: oc.productCate,
										productNo: oc.productNo,
										suserCode: oc.suserCode,
										suserName: oc.suserName,
										unitPrice: oc.unitPrice,
										count: oc.count,
										proId: oc.proId,
										sid: oc.sid,
										avaiNumber: oc.avaiNumber,
										unitPriceE:oc.unitPrice,
                                        currency:oc.currency,
                                        yremark:oc.yremark,
                                        banfn :oc.banfn,
                                        bnfpo:oc.bnfpo,
                                        currency:oc.currency
									})
								})


                            }

                        }

                    })


                }

            },


            //加载当前自己的原始信息
            jiazaiobjxinxi(q) {

                //初始化默认数据
                this.zy = q;
                //查询数据如果文件id是空就附上默认参数 hyl
                if(this.zy.fileId == null || this.zy.fileId == undefined){
                    this.zy.fileId = this.$util.getUuid();
                }else{
                    //给fileUrl随便赋值防止提交提示未上传附件
                    this.zy.fileUrl = this.zy.fileId;
                }
            },


            //加载兄弟信息
            jiazaixiongdi(q) {

                var orderCg = {

                    instidlist: [],
                    taskId: this.$route.query.taskid,

                };

                for (var s in q) {

                    this.adds();

                    orderCg.instidlist.push(q[s].instid)

                }


                console.log(orderCg, '入参')

                ss.orderCgService.shuaixuanInstid(orderCg).then(rd => {

                    console.log(rd, '可以显示的，需要审批的')

                    //过滤存在
                    if (rd.obj && rd.obj.length!=0  && this.$route.query.taskid) {

                        this.shenpixianshi = rd.obj;

                        var qq = [];

                        for (var c in q) {

                            for (var d in rd.obj) {

                                if (q[c].instid == rd.obj[d]) {

                                    qq.push(q[c])

                                }

                            }

                        }

                        this.tableData3 = [];

                        for (var c in qq) {

                            this.tableData3[c] = qq[c];

                        }

                    } else {

                        for (var c in q) {

                            this.tableData3[c] = q[c];

                        }

                    }
                    var total=0;
                    for(var i=0;i<this.tableData3.length;i++){
                        var data = this.tableData3[i];
                        if(data.count && data.unitPrice){
                            total=new big(data.unitPrice).times(data.count).plus(total).toFixed(2);
                        }
                    }
                    this.zy.totalPrice = total;

                    for (var m in this.tableData3) {


                        this.tableData3[m].productOptions = this.tableData3[m].product2OemSelectresult;


                        for (var d in this.tableData3[m].productType) {

                            if (d == 'id' && this.tableData3[m].productCate == d) {

                                this.tableData3[m].productCateName = this.tableData3[m][d].levelname;

                            }

                        }


                        this.tableData3[m].productOptions = this.tableData3[m].product2Selectresult;

                        if (this.tableData3[m].productOptions) {
                            //设置产品型号名称
                            this.tableData3[m].productOptions.forEach((item, index) => {
                                if (this.tableData3[m].productNo == item.id) {
                                    this.tableData3[m].productDes = item.levelname;
                                }
                            })
                        }

                        this.vs.productId = this.tableData3[m].productNo;


                        this.tableData3[m].options2 = this.tableData3[m].supplierByProductIdresult;


                    }


                })


            },


            //清空选择型号
            qingkong() {

                this.$msg.confirm("确认清空？", () => {

                    this.f.numlist = null;

                })

            },


            //删除框
            delPlan(index, q) {

                console.log(q, 'qaaaaa')

                this.$confirm('确认删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				})
                    .then(_ => {

                        //如果原来有数据
                        if (q.id != null) {//把要删除的主键id存起来
                            this.yaoshanchude.push({id: q.id});


                        }
                        this.tableData3.splice(index, 1)
                        //console.log(index,"删除一行数据");

                    })
                    .catch(_ => {

                    });

            },


            //增加行
            adds() {
            if(!this.zy.type){
              this.$message.info('请先选择采购单类型')
               return
            }

                var list = {

                    productCateName: '',
                    productDes: '',
                    productCate: '',
                    productNo: '',
                    productOptions: [],
                    suserCode: '',
                    suserName: '',
                    options2: [],
                    unitPrice: '',
                    count: '',
                    proId: '',
                    currency: '',

                    banfn : '',
                    bnfpo: '',
                }


                this.tableData3.push(list)

            },

            //产品大类下拉框
            selectProduct1() {
                ss.ProService.product1Select().then(rd => {
                    this.productType = rd;
                })
            },


            //大类修改时，当块数据proProduct[i]-v,index-i
            changeBig(v) {

                v.productNo = '';
                v.unitPrice = '';
                v.count = '';
                v.productCateName = '';
                v.productDes = '';
                v.options2 = [];
                v.suserCode = '';
                v.suserName = '';
                v.proId = '';

                this.zy.totalPrice = '';

                this.productType.forEach((item, index) => {
                    if (v.productCate == item.id) {
                        v.productCateName = item.levelname;
                    }
                })

                // this.options1 = [];

                this.selectProduct2(v);

            },


            //大类修改时，查询小类列表 v.type大类id-v,index-i
            selectProduct2(v) {
              if(this.zy.type != 3){ //1:内销订单采购  2 //"外销订单采购"  3 //"上海直销订单"
                ss.ProService.product2StockOemSelect(v.productCate).then(rd => {
                  v.productOptions = rd;
                  this.$set(v.productOptions, rd);
                })
              } else {
                ss.ProService.product2OemSelect(v.productCate).then(rd => {
                  v.productOptions = rd;
                  this.$set(v.productOptions, rd);
                })
              }

            },


            changeNum(v) {
				var total=0;
				for(var i=0;i<this.tableData3.length;i++){
					var data = this.tableData3[i];
					if(data.count && data.unitPrice){
						total=new big(data.unitPrice).times(data.count).plus(total).toFixed(2);
					}
				}
				this.zy.totalPrice = total;
            },
            cancel() {
                this.$router.push("purchaselist");
            },


            submit(form) {
                var flag = false;
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        flag = true;
                    } else {
                        return false;
                    }
                });
                //判断下单数量与特价数量
                var flagNum = false;
                this.tableData3.forEach((item, index) => {
                    if (item.specialPrice && item.count > item.avaiNumber) {
                        flagNum = true;
                    }
                })
                if(this.zy.purchaseOrgCode != '1R60'){
                    if(this.zy.fileUrl == '' ||this.zy.fileUrl == null ){
                        this.$msg.msge("请上传附件！");
                        return;
                    }
                }

                if (flag) {
                    //判断数据完整
                    if (this.shoudongpanduan()) {
                        this.$msg.msge("请先填写完整信息并保证信息准确性")
                    } else {
                        if (flagNum) {
                            this.$msg.msge("特价产品下单数量不可大于特价余量！");
                        } else {
                            this.newtijiao();
                        }
                    }
                }

            },


            //手动判断
            shoudongpanduan() {

                var s = false;

                for (var c in this.tableData3) {

                    if (

                        (this.tableData3[c].productCate == null || this.tableData3[c].productCate == '') ||
                        (this.tableData3[c].suserCode == null || this.tableData3[c].suserCode == '') ||
                        (this.tableData3[c].productNo == null || this.tableData3[c].productNo == '') ||
                        (this.tableData3[c].count == null || this.tableData3[c].count == '') ||
                         (this.tableData3[c].unitPrice === null || this.tableData3[c].unitPrice === '')

                    ) {

                        s = true;

                    } else {

                        let ex = /^[1-9]\d{0,9}$/
                        if (!ex.test(this.tableData3[c].count)) {
                            s = true;
                        }

                    }


                }

                return s;

            },


            //构造参数
            gouzaocanshu() {

                var entitylist = [];

                for (var c in this.tableData3) {

                     if (this.tableData3[c].unitPrice === null || this.tableData3[c].unitPrice === '') {
                        this.$msg.msge("请完善采购订单数据！");
                    }
                    entitylist.push({

                        numlist: this.zy.numlist,
                        type: this.zy.type,
                        waybillType: this.zy.waybillType,
                        detailAddress: this.zy.detailAddress,
                        expectDate: this.zy.expectDate,
                        status: this.zy.status,
                        cgGroupCode: this.zy.cgGroupCode,
						purchaseOrgCode: this.zy.purchaseOrgCode,
                        province: this.zy.province,
                        city: this.zy.city,
                        country: this.zy.country,
                        receiver: this.zy.receiver,
                        receverPhone: this.zy.receverPhone,
                        receiveUnit: this.zy.receiveUnit,
                        fileId: this.zy.fileId,
                        instid: this.instId || null,
                        cgId: this.tableData3[c].cgId || '',
                        zhubiaoid: this.tableData3[c].zhubiaoid || '',
                        productCateName: this.tableData3[c].productCateName,
                        productDes: this.tableData3[c].productDes,
                        productCate: this.tableData3[c].productCate,
                        productNo: this.tableData3[c].productNo,
                        suserCode: this.tableData3[c].suserCode,
                        suserName: this.tableData3[c].suserName,
                        unitPrice: this.tableData3[c].unitPrice,
                        count: this.tableData3[c].count,
                        proId: this.tableData3[c].proId,
						totalPrice: new big(this.tableData3[c].unitPrice).times(this.tableData3[c].count),
						sid: this.tableData3[c].sid,
						avaiNumber: this.tableData3[c].avaiNumber,
                        yremark: this.tableData3[c].yremark,
                        banfn :this.tableData3[c].banfn==""?null:this.tableData3[c].banfn,
                        bnfpo:this.tableData3[c].bnfpo == ""?null:this.tableData3[c].bnfpo,
                        currency: this.tableData3[c].currency,
                        oemDesc: this.tableData3[c].oemDesc,
                        warehouse: this.zy.warehouse,
                        notes: this.zy.notes,
                        hhxmCode: this.zy.hhxmCode,
                        startTimeHhxm: this.zy.startTimeHhxm,
                        endTimeHhxm: this.zy.endTimeHhxm,
                    })

                }

                return entitylist;

            },


            //新list提交方法
            newtijiao() {
                var flag = false;
                this.$refs['form1'].validate((valid) => {
                    if (valid) {
                        flag = true;
                    } else {
                        this.$msg.msge("请完善采购订单数据！");
                        return false;
                    }
                });
                if (!flag) {
                    return;
                }
				this.changeNum();
                this.zy.expectDate = util.riQi6(this.zy.expectDate)

                //审批驳回提交
                if (this.ywId != null && this.instId != null) {
                    ss.orderCgService.renewOrderCglist(this.gouzaocanshu()).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$store.dispatch('searchTasktotal');
                            this.$router.push("purchaselist");
                        } else {
                            this.$msg.msge("提交失败！" + rd.msg);
                        }
                    })

                    //普通提交
                } else {

                    this.zy.status = 1;
                    if(this.zy.type == '1' || this.zy.type == '2'){
                        this.zy.waybillType ='3'
                    }
                    ss.orderCgService.createCgOrderlist(this.gouzaocanshu()).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$router.push("purchaselist");
                        } else {
                            this.zy.status = "";
                            this.$msg.msge("提交失败！" + rd.msg);
                        }
                    })
                }
            },


            //旧蔡工单提交方法
            oldtijiao() {
                var flag = false;
                this.$refs['form1'].validate((valid) => {
                    if (valid) {
                        flag = true;
                    } else {
                        this.$msg.msge("请完善采购订单数据！");
                        return false;
                    }
                });
                if (!flag) {
                    return;
                }
                this.zy.expectDate = util.riQi6(this.zy.expectDate)

                //审批提交
                if (this.ywId != null && this.instId != null) {
                    ss.orderCgService.renewOrderCg(this.zy).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$store.dispatch('searchTasktotal');
                            this.$router.push("purchaselist");
                        } else {
                            this.$msg.msge("提交失败！" + rd.msg);
                        }
                    })

                    //普通提交
                } else {
                    this.zy.status = 1;
                    ss.orderCgService.createCgOrder(this.zy).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$router.push("purchaselist");
                        } else {
                            this.$msg.msge("提交失败！" + rd.msg);
                        }
                    })
                }
            },

            //暂存
            save() {

                this.savenew();

            },


            //新暂存list
            savenew() {
                this.tableData3.forEach((item, index) => {
                    item.unitPrice = item.unitPriceE;
                })
                this.zy.status = 0;
                if (this.zy.expectDate) {
                    this.zy.expectDate = util.riQi6(this.zy.expectDate)
                }
                if(this.zy.type == '1' || this.zy.type == '2'){
                    this.zy.waybillType ='3'
                }
                ss.orderCgService.createCgOrderlist(this.gouzaocanshu()).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs("提交成功！");
                        this.$router.push("purchaselist");
                    } else {
                        this.zy.status = "";
                        this.$msg.msge("提交失败！" + rd.msg);
                    }
                })

            },


            //旧蔡工单暂存
            saveold() {

                this.zy.status = 0;
                if (this.zy.expectDate) {
                    this.zy.expectDate = util.riQi6(this.zy.expectDate)
                }
                ss.orderCgService.createCgOrder(this.zy).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs("提交成功！");
                        this.$router.push("purchaselist");
                    } else {
                        this.$msg.msgs("提交失败！" + rd.msg);
                    }
                })

            },


            choseDizhi(obj) {
                this.zy.detailAddress = obj.quobj.namepath;
                if (obj.zhenobj) {
                    this.zy.detailAddress = obj.zhenobj.namepath;
                }
                this.zy.detailAddress = this.zy.detailAddress + obj.addrdetail;
                this.zy.province = obj.shengobj.name;
                this.zy.city = obj.shiobj.name;
                this.zy.country = obj.quobj.name;
                this.showdizhiflag = false;
            },
            //选择地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },
            //处理 附件id
            upload(v) {
                if (v.length > 0) {
                    v.forEach(e => {
                        this.zy.fileUrl = e.saveurl
                    })
                }else{
                    this.zy.fileUrl =null;
                }
            },
            //获取采购默认值
            getCgDefault(){
                ss.orderCgService.getDefaultCg().then(rd => {
                    if(rd.f){
                        this.zy.detailAddress = rd.msg.receiveAddress;
                        this.zy.receiver = rd.msg.receiver;
                        this.zy.receiveUnit = rd.msg.receiveUnit;
                        this.zy.receverPhone = rd.msg.receiverPhone;
                    }
                })
            },
            //保存采购默认参数
            saveDefault() {
              var saveData = {};
              saveData.receiver = this.zy.receiver;
              saveData.receiveUnit = this.zy.receiveUnit;
              saveData.receiverPhone = this.zy.receverPhone;
              saveData.receiveAddress = this.zy.detailAddress;
              saveData.purchaseOrgCode = this.zy.purchaseOrgCode;
              if(this.ckFlag){
                  saveData.kuwei = this.zy.warehouse;
                  saveData.purchaseOrgCode = this.zy.purchaseOrgCode;
              }else {
                  saveData.kuwei = "青岛库";
                  //saveData.purchaseOrgCode = "9OE1,9OE2,9OE3,1RK0,6XG1,1JC0,0PN1";
              }
              ss.orderCgService.saveCgDefault(saveData).then(rd=>{
                  if(rd.f){
                      this.getCgDefault();
                  }
              })
            },
            changeCgGroup(){
                var category = 'cg_org_group';
                var code = this.zy.purchaseOrgCode;
                if(this.zy.purchaseOrgCode == '1R60'){
                    this.ckFlag = true;
                }else {
                    this.ckFlag = false;
                }
                if(this.zy.purchaseOrgCode == '1S00' || this.zy.purchaseOrgCode == '1S40'){
                    this.hhxmFlag = true;
                    //查询厚宏项目合同
                    ss.contractService.getHhxmContract("").then(rd => {
                        this.hhxmList = rd.msg;
                    })
                }else {
                    this.hhxmFlag = false;
                }
                //根据选中的采购组织编码获取采购组
                ss.Dictservice.getDictByCateCode(category,code).then(rd =>{
                    this.zy.cgGroupCode = rd.name;
                })
                var data = {}
                data.purchaseOrgCode = this.zy.purchaseOrgCode;
                data.kuwei = '青岛库';
                //获取默认收货信息
                ss.orderCgService.getDefaultCg(data).then(rd => {
                    if(rd.f && null != rd.msg){
                        this.zy.detailAddress = rd.msg.receiveAddress;
                        this.zy.receiver = rd.msg.receiver;
                        this.zy.receiveUnit = rd.msg.receiveUnit;
                        this.zy.receverPhone = rd.msg.receiverPhone;
                    }else {
                      this.zy.detailAddress = '';
                      this.zy.receiver = '';
                      this.zy.receiveUnit = '';
                      this.zy.receverPhone = '';
                    }
                })
            },
            changeWarehouse(){
                var data = {}
                data.purchaseOrgCode = this.zy.purchaseOrgCode;
                data.kuwei = this.zy.warehouse;
                //获取默认收货信息
                ss.orderCgService.getDefaultCg(data).then(rd => {
                    if(rd.f){
                        this.zy.detailAddress = rd.msg.receiveAddress;
                        this.zy.receiver = rd.msg.receiver;
                        this.zy.receiveUnit = rd.msg.receiveUnit;
                        this.zy.receverPhone = rd.msg.receiverPhone;
                    }
                })
            },
            changeHhxmCode(value){
                if(value == null || value == ""){
                    this.isHHxm = false;
                }else {
                    this.isHHxm = true;
                }
            },
        }



    }
</script>
<style>
    .h-formbLine .weekplandetail111 .el-form-item__label {
        width: 35%;
        text-align: right;
    }

    .h-formbLine .weekplandetail111 .el-form-item__content {
        width: 65%;
    }

    .h-formbLine .weekplandetail111 .h-elformWrap-2 {
        width: 33.333%!important;
        padding-right: 0.5rem
    }

    .h-formbLine .weekplandetail111 .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .h-formbLine .weekplandetail111 .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .h-formbLine .weekplandetail111 .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;

        }

        .steps {
            position: absolute;
            z-index: 1;

        }

        .step1 {
            top: 2.1rem;
            left: 3.3rem;
            width: 15rem;
            height: 2rem;
        }

        .step2 {
            top: 6.9rem;
            right: 7.8rem;
            width: 4.4rem;
            height: 1rem;
        }

        .step3 {
            top: 6.9rem;
            right: 2.9rem;
            width: 1.9rem;
            height: 1rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>
